export const hasAnswerText = (answer) => Boolean(answer?.trim());
